import { render, staticRenderFns } from "./PricelistPrepaid.vue?vue&type=template&id=34ed3544&"
import script from "./PricelistPrepaid.vue?vue&type=script&lang=js&"
export * from "./PricelistPrepaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports